<ng-container *ngIf="memberCard$ | async as memberCard; else loadingRef">
  <div class="member-card bg-primary">
    <div class="d-flex flex-row align-items-center justify-content-between">
      <!--Name and ID-->
      <div class="card-id text-left">
        <h4 class="card-name font-size-18 text-uppercase text-white m-0" *ngIf="memberDetails$ | async as memberDetails">
          {{ memberDetails.FirstName }} {{ memberDetails.Surname }}
        </h4>
        <div class="d-flex font-size-10">
          <div class="product-code font-size-14 text-white">
            {{ memberCard.ProductCode }} - {{ memberCard.ExternalRefNumber }}
          </div>
        </div>
      </div>

      <img class="card-logo" src="assets/images/card-logo.png" alt="" />
    </div>

    <!--Balances-->
    <div class="balance bg-glass-dark d-flex flex-row justify-content-between align-items-center">
      <span class="font-size-14 text-white text-capitalize">{{ 'barcode.your.points' | translate }}</span>

      <div class="points-container d-flex flex-row align-items-center justify-content-center">
        <span class="icons material-icons text-white" aria-hidden="true">loyalty</span>
        <span class="fw-bold text-white font-size-20 font-heading">{{ pointsBalance$ | async | number: '1.0-0' }}</span>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loadingRef>
  <fgbcl-loading></fgbcl-loading>
</ng-template>
